import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB0_gG_T-cJ24NpIycACIkfxPi9Xt0pdxs",
  authDomain: "skinsoul-31ff2.firebaseapp.com",
  projectId: "skinsoul-31ff2",
  storageBucket: "skinsoul-31ff2.firebasestorage.app",
  messagingSenderId: "733644216610",
  appId: "1:733644216610:web:bf77b09e81580e2dc7ed7b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Auth
export const auth = getAuth(app);

export default app; 